import { render } from "./CourseCards.vue?vue&type=template&id=114910ae&scoped=true"
import script from "./CourseCards.vue?vue&type=script&lang=js"
export * from "./CourseCards.vue?vue&type=script&lang=js"

import "./CourseCards.vue?vue&type=style&index=0&id=114910ae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s574086\\textbook-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-114910ae"]])

export default __exports__